export default {
  Details: {
    Title: 'Complete Order',

    OrderDetails: {
      Title: 'Your Order'
    },

    CustomerDetails: {
      Title       : 'Customer Details',
      Notification: {
        Login          : 'Already have an account?',
        Logout         : 'Welcome back {user}. Aren\'t you?',
        NoAccount      : 'No, I don\'t have an account.Do',
        ContinueAsGuest: 'or continue as a guest.'
      },
      Field: {
        Firstname: {
          Label      : 'Name',
          Placeholder: '',
          Hint       : ''
        },
        Lastname: {
          Label      : 'Surname',
          Placeholder: '',
          Hint       : ''
        },
        Email: {
          Label      : 'Email',
          Placeholder: '',
          Hint       : ''
        },
        Phone: {
          Label      : 'Mobile',
          Placeholder: '',
          Hint       : ''
        }
      }
    },

    DeliveryDetails: {
      Title       : 'Address Details',
      Notification: {
        Confirm             : 'Please confirm that your address is filled correctly.',
        ConfirmLatLngAddress: 'Please confirm that the pin is in the correct location on the map and that your address has been filled correctly.',
        OutOfBounds         : 'The address is not within the delivery area.',
        Select              : 'You must select or add an address.'
      },
      Field: {
        Autocomplete: {
          Label: 'Address Search',
          Hint : ''
        },
        AddressComments: {
          Label: 'Οδηγίες διεύθυνσης',
          Hint : 'Επιπλέον οδηγίες για την διεύθυνση.'
        },
        City: {
          Label: 'Περιοχή',
          Hint : 'Εισάγετε την περιοχή της διεύθυνσης.'
        },
        DoorBell: {
          Label: 'Κουδούνι',
          Hint : 'Όνομα που αναγράφεται στο κουδούνι'
        },
        Floor: {
          Label: 'Όροφος',
          Hint : 'πχ. 1ος, Ισόγειο, Μεζονέτα, Μονοκατοικία, κλπ.'
        },
        FriendlyName: {
          Label: 'Φιλική Ονομασία',
          Hint : 'πχ. Σπίτι, Γραφείο, κλπ.'
        },
        Number: {
          Label: 'Αριθμός',
          Hint : 'Εισάγετε τον αριθμό της διεύθυνσης.'
        },
        Postcode: {
          Label: 'Τ.Κ.',
          Hint : 'πχ. 153 54'
        },
        Street: {
          Label: 'Οδός',
          Hint : 'Εισάγετε την οδό της διεύθυνσης.'
        }
      }
    },

    OrderComments: {
      Title: 'Order Comments',
      Field: {
        Comments: {
          Label      : 'Order Comments',
          Placeholder: '',
          Hint       : ''
        }
      }
    },

    PaymentDetails: {
      Title: 'Order Payment'
    }
  },

  Success: {
    Title: 'Order Status',

    Status: {
      Title: 'Order Status with code:',
      Body : 'We will notify you when each order is ready for pickup from the respective store.<br>Want to change something? Contact the store directly.'
    },

    Scheduled: {
      Delivery: {
        Title: 'It will be at your door'
      },
      Collection: {
        Title: 'You Will Receive'
      }
    },

    BrandSlider: {
      Title: 'Our Stores'
    },

    Stores: {
      Title : 'Stores',
      Status: {
        Title: 'Order Status',
        Time : 'Estimated Time'
      }
    },

    NotFound: {
      Title   : 'Order not found!',
      Subtitle: 'Discover amazing stores, add products and create an order!'
    }
  },

  Failure: {
    Title: 'Order Failure',

    Status: {
      Title: 'Order Failure',
      Body : 'Unfortunately, the order failed and was not executed. Try again later.'
    },

    BrandSlider: {
      Title: 'Our Stores'
    },

    Stores: {
      Title : 'Stores',
      Status: {
        Time: 'Estimated Time'
      }
    },

    NotFound: {
      Title   : 'Order not found!',
      Subtitle: 'Discover amazing stores, add products and create an order!'
    }
  },

  Button: {
    CompleteOrder: 'Complete Order'
  }
}
